import styled from 'styled-components';

import React from 'react';

const BarLoader = ({ isLoading }) => {
  return (
    <>
      {isLoading && (
        <div style={{ marginTop: 16, display: 'flex', justifyContent: 'end' }}>
          <BarsLoader>
            <span></span>
            <span></span>
            <span></span>
          </BarsLoader>
        </div>
      )}
    </>
  );
};

export default BarLoader;

const BarsLoader = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 4px;
  height: 10px;
  gap: 3px;
  position: absolute;
  right: 17px;

  span {
    width: 4px;
    background: #722ed1;
    animation: barAnim 0.8s infinite;
  }

  span:nth-child(1) {
    animation-delay: 0s;
  }
  span:nth-child(2) {
    animation-delay: 0.1s;
  }
  span:nth-child(3) {
    animation-delay: 0.2s;
  }

  @keyframes barAnim {
    0%,
    100% {
      height: 6px;
      opacity: 0.3;
    }
    50% {
      height: 12px;
      opacity: 1;
    }
  }
`;
